import {
    ComposeMessageEditorErrorType,
    ComposeStateType,
} from "../../reducer.types";

/**
 * Returns an error if the user attached a
 * questionnaire and tried to send while it was still
 * loading (we check whether the patient can be enrolled in the
 * questionnaire before adding it to the message)
 */
export const validateQuestionnaireLoading = ({
    template,
}: {
    template: ComposeStateType["template"];
}): Pick<ComposeMessageEditorErrorType, "questionnaireLoading"> => {
    return template.type === "PendingQuestionnaireTemplate"
        ? { questionnaireLoading: "QUESTIONNAIRE_STILL_LOADING" }
        : {};
};
